import { IconButton, SxProps, Tooltip } from '@mui/material'
import SyncIcon from '@mui/icons-material/Sync'

interface RefreshButtonProps {
  dataTestId?: string
  title?: string
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void | (() => void)
  sx?: SxProps
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
    | undefined
  color?:
    | 'action'
    | 'disabled'
    | 'primary'
    | 'inherit'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
}

function RefreshButton({
  title = 'Clear Filters',
  onClick,
  sx,
  placement = 'bottom',
  color = 'primary',
  dataTestId,
}: RefreshButtonProps) {
  return (
    <Tooltip title={title} placement={placement}>
      <IconButton onClick={onClick} data-testid={dataTestId}>
        <SyncIcon sx={sx} color={color} />
      </IconButton>
    </Tooltip>
  )
}

export default RefreshButton
